import axiosInstance from "../api/axios";

export const UpdateIncome = async (payload) => {
  const res = await axiosInstance.post("/api/user/update-income", payload);
  return res.data;
};

export const GetIncomeDetails = async ({ currentMonth }) => {
  const res = await axiosInstance.get(
    `/api/user/get-income?month=${currentMonth}`
  );
  return res.data;
};

export const GetExpenseDetails = async ({ currentMonth }) => {
  const res = await axiosInstance.get(
    `/api/user/get-expense?month=${currentMonth}`
  );
  return res.data;
};

export const UpdateExpenses = async (payload) => {
  const res = await axiosInstance.post("/api/user/update-expense", payload);
  return res.data;
};
